var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.044 12.371v5.791a1.287 1.287 0 01-1.288 1.287H6.243a1.287 1.287 0 01-1.287-1.287v-5.79M12.5 8.16s1.269-2.583 2.452-3.267c1.34-.775 2.48.653 1.473 1.528-1.022.89-3.925 1.74-3.925 1.74zM11.5 8.16s-1.269-2.583-2.452-3.267c-1.34-.775-2.48.653-1.473 1.528 1.022.89 3.925 1.74 3.925 1.74z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M10.084 12.371H13.8v7.078h-3.716zM10.084 8.16H13.8v4.211h-3.716z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.829,
    y: 8.16,
    width: 16.343,
    height: 4.211,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
export default SvgGiftback;